var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "audio", on: { click: _vm.autoPlay } }, [
    _c("img", {
      staticClass: "icon",
      attrs: {
        src: require(`../assets/${_vm.isPlay ? `play.gif` : `ic_live.png`}`),
        alt: "",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }